export const PRIVILEGE_TYPE = {
    REWARD : 1,
    CPC : 4,
    TOPUP : 5,
    EXCHANGE : 6,
    getTypeDesc : (id) => {
        return {
            [PRIVILEGE_TYPE.REWARD] : "Reward/Privilege",
            [PRIVILEGE_TYPE.CPC] : "Coupon Code",
            [PRIVILEGE_TYPE.TOPUP] : "Mobile Topup",
            [PRIVILEGE_TYPE.EXCHANGE] : "Exchange"
        }[id]
    }
}

export const COUPON_CODE_TYPE = {
    EXTERNAL : 5
}
    
export const EXTRA_PAYLOAD_TYPE = {
    STRING : 1,
    INT : 2,
    DECIMAL : 4,
    BOOL : 8,
    DATETIME : 16,
    JSON : 1024,
}